import { Component, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { ContactType } from '../models/Enums';
import { DataService } from "../services/dataService";
import { Alert } from "../shared/modal/alert";
import { ValidationBase } from "../validation/validationBase";
import { ValidationMessage } from "../validation/validationMessage";
import { ValidationMessageType } from "../validation/validationMessageType";
import { EmailValidator } from "../validation/validators/emailValidator";
import { PhoneValidator } from "../validation/validators/phoneValidator";




@Component({
    selector: "jax-parentprofilecomponent",
    templateUrl: "./parentprofile.component.html"
})

export class ParentProfileComponent extends ValidationBase {
    public iNotifyError;
    public emailValidator = new EmailValidator();
    public phoneValidator = new PhoneValidator();
    public parentprofile: any = {};
    public parentprofileOld: any = {};
    public contactTypes: any = {};
    public contactTypeEnum = ContactType;
    private currentUser: any;
    public isCompleted = false;
    public validationMessage: ValidationMessage;
    public hasSuccess: boolean;
    public JSON: any = JSON;
    public alertType="";
    public primaryContactTypeId=0;

    public rowsOnPage = 10;
    public sortBy = "";
    public sortOrder = "";
    public activePage = 1;

    @ViewChild(Alert) alert: Alert;

    constructor(private dataService: DataService, private router: Router) {
        super();
        this.iNotifyError = this;
    }

    public ngOnInit() {
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));

        this.dataService.get("extuser/contacttypes").subscribe(
            (resp) => {
                this.contactTypes = resp;
            });

        this.isCompleted = false;
        this.dataService.get("extuser/contactinformation?userId=" + this.currentUser.UserId).subscribe(
            (resp) => {
                this.parentprofile = resp;
                this.parentprofileOld = JSON.parse(JSON.stringify(this.parentprofile));
                let contact = this.parentprofile.ContactInformation.find(c=>c.IsPrimary==true);
                if(contact){
                    this.primaryContactTypeId=contact.ContactType
                }
                this.isCompleted = true;
            },
            (error) => {
                this.validationMessage = error.message;
                this.isCompleted = true;
            });
    }

    public clearSubmit() {
        this.parentprofile = JSON.parse(JSON.stringify(this.parentprofileOld));
        let contact = this.parentprofile.ContactInformation.find(c=>c.IsPrimary==true);
        if(contact){
            this.primaryContactTypeId=contact.ContactType
        }
    }

    public validateEmail(item: any) {
        let emailId = item.ContactValue;
        if (this.IsValidEmail(emailId) || emailId.length===0) {
            if(item.IsPrimary && emailId.length===0){
                item.isError = true;
                item.ErrorMessage = "Primary contact cannot be empty";
            }
            else
            {
                item.isError = false;
                item.ErrorMessage = "";
            }
        }
        else {
            item.isError = true; 
            item.ErrorMessage = "Invalid " + item.ContactTypeName;
        }
    }

    public phoneFormat(item: any) {
        let phoneNumber = item.ContactValue;
        if (this.IsValidPhone(phoneNumber) || phoneNumber.length===0) {
            if(phoneNumber.length>0){
                if (!isNaN(phoneNumber)) {
                    phoneNumber = phoneNumber.substring(0, 3) + "-" + phoneNumber.substring(3, 6) + "-" + phoneNumber.substring(6, 10);
                }
                else {
                    phoneNumber = phoneNumber.replace(")-", ") ");
                }
                item.ContactValue = phoneNumber;
                item.isError = false;
                item.ErrorMessage = "";
            }
            else{
                if(item.IsPrimary && phoneNumber.length===0){
                    item.isError = true;
                    item.ErrorMessage = "Primary contact cannot be empty";
                }
                else
                {
                    item.isError = false;
                    item.ErrorMessage = "";
                }
            }
        }
        else{
            item.isError = true; 
            item.ErrorMessage = "Invalid " + item.ContactTypeName;
        }
    }

    private IsValidEmail(emailId: string) {
        if (!emailId) {
            return true;
        }

        return this.emailValidator.validateEmail(emailId);
    }

    private IsValidPhone(phoneNumber: string) {
        return this.phoneValidator.validatePhone(phoneNumber);
    }

    public processChange(primaryContactTypeId:number) {
        this.parentprofile.ContactInformation.forEach((element,i) => {
                if(element.ContactType==primaryContactTypeId){
                    element.IsPrimary = true;
                    element.IsEnd = false;
                }
                else{
                    element.IsPrimary = false;
                }
        });
    }

   
    public confirmOpenWithdraw(IsPrimary, IsEnd) {
        if (IsPrimary && IsEnd) {
            this.alertType="Withdraw";
            this.alert.cancelButton = false;
            this.alert.okButton = true;
            this.alert.alertTitle = "Contact Information?";
            this.alert.message = "Primary contact cannot be withdrawn";
            this.alert.okButtonText = "Ok";
            this.alert.okButtonType = "btn-danger";
            this.alert.open();
            return false;
        }
        else {
            return IsEnd;
        }
    }

    public confirmOpenSubmit() {

        let endedContactInfo = this.parentprofile.ContactInformation.filter(c => c.IsEnd == true);
        if (endedContactInfo.length > 0) {
            this.alertType="Submit";
            this.alert.cancelButton = true;
            this.alert.okButton = true;
            this.alert.alertTitle = "Submit changes?";
            this.alert.message = "You have withdrawn some contact(s).Do you want to continue?";
            this.alert.okButtonText = "Yes";
            this.alert.okButtonType = "btn-danger";
            this.alert.cancelButtonText = "No";
            this.alert.open();
            return;
        }
        else {
            this.submit();
        }

    }

    public confirmCloseSubmit(event) {
        if(this.alertType=="Submit"){
            this.submit();
        }
    }

    private validateGrid(): void {
        this.parentprofile.isError = false;
        this.parentprofile.ErrorMessage = "";

        if (!this.parentprofile.ContactInformation.length) {
            this.parentprofile.isError = true;
            this.parentprofile.ErrorMessage = "Invalid";
            return;
        }

        this.parentprofile.ContactInformation.forEach((contact, index) => {
            if (contact.ContactType == ContactType.EmailAddress) {
                 this.validateEmail(contact);
            }
            else {
                this.phoneFormat(contact);
            }

            if(contact.length>0){
                let duplicateContact = this.parentprofile.ContactInformation.filter(c=>c.ContactValue==contact.ContactValue);

                if(duplicateContact.length>1){
                    contact.isError = true;
                    contact.ErrorMessage = "Duplicate contact";
                }
            }
            if(!this.parentprofile.isError){
                this.parentprofile.isError = contact.isError;
                this.parentprofile.ErrorMessage = contact.ErrorMessage;
           }

        });
    }

    public addContactRow() {
        let contactRow:any;
        this.contactTypes.forEach((contact, index) => {
             let contactExists = this.parentprofileOld.ContactInformation.findIndex(c=>c.ContactType==contact.Id);
             if(contactExists<0){
                contactRow = {
                    "ContactInformationId": 0,
                    "ContactType": contact.Id,
                    "ContactTypeName": contact.Name,
                    "ContactValue": "",
                    "IsEnd" :false,
                    "IsPrimary": false
                };
                this.parentprofile.ContactInformation.push(contactRow);
            }
        });
    }

    public removeContactRow(rowIndex: number) {
       let contact = this.parentprofile.ContactInformation[rowIndex];
        if (contact.ContactInformationId > 0) {
        } else {
            this.parentprofile.ContactInformation.splice(rowIndex, 1);
        }
    }

public submit() {

        this.validationMessage = null;
        let message = new ValidationMessage();

        if (JSON.stringify(this.parentprofile) === JSON.stringify(this.parentprofileOld)) {
            message.messageType = ValidationMessageType.Error;
            message.message = 'No changes detected, Profile not updated';
            this.validationMessage = message;
            return;
        }

        this.validateGrid();
        if (this.parentprofile.isError) {
            message.messageType = ValidationMessageType.Error;
            message.message = this.parentprofile.ErrorMessage;
            this.validationMessage = message;
            this.parentprofile.isError=this.parentprofileOld.isError;
            this.parentprofile.ErrorMessage=this.parentprofileOld.ErrorMessage;
            return;
        }



        this.parentprofile.UserId = this.currentUser.UserId;
        this.dataService.post("extuser/updatecontactinformation", JSON.stringify(this.parentprofile))
        .subscribe((response) => {
            if (response.Succeeded == 1) {
                this.hasSuccess = true;
                message.messageType = ValidationMessageType.Ok;
                this.parentprofileOld.ContactInformation =  JSON.parse(response.UpdatedContact);
                this.parentprofile = JSON.parse(JSON.stringify(this.parentprofileOld));
            } else {
                this.hasSuccess = false;
                message.messageType = ValidationMessageType.Error;
            }
            message.message = response.Message;
            this.validationMessage = message;
        },
        error => {
            this.hasSuccess = false;
            message.message = error.message || error.message.Message;
            message.messageType = ValidationMessageType.Error;
            this.validationMessage = message;
        });
    }
}